export default function Footer() {
  return (
    <footer className="bg-[#13A699] text-[#FFF7ED] mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <div className="font-display text-2xl font-bold">rate-ED</div>
          <p className="mt-2 text-sm opacity-90">Make Your Child Skill Independent.</p>
        </div>
        <div>
          <div className="font-display font-semibold mb-2">Explore</div>
          <ul className="space-y-1 text-sm opacity-90">
            <li>Career Skills</li>
            <li>Activities</li>
            <li>Sports</li>
            <li>Academics</li>
          </ul>
        </div>
        <div>
          <div className="font-display font-semibold mb-2">Contact</div>
          <p className="text-sm opacity-90">hello@rate-ed.app</p>
        </div>
      </div>
      <div className="border-t border-white/20 py-4 text-center text-xs opacity-80">
        © {new Date().getFullYear()} Rate-ED. All rights reserved.
      </div>
    </footer>
  );
}
